var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cg-leyenda"},_vm._l((_vm.unidades),function(u){return _c('span',{key:u.uid,staticClass:"cg-item"},[_c('i',{staticClass:"cg-sw",style:({ background: u.hex })}),_c('b',[_vm._v(_vm._s(u.alias))]),(u.patente && u.patente !== u.alias)?_c('span',{staticClass:"cg-pat"},[_vm._v(_vm._s(u.patente))]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }